module.exports = __webpack_public_path__ + "static/media/Bird11.634e1405.jpg";